<template lang="pug">
.report-page
  .title-section Stock

  form(@submit.prevent="")
    .input-container.arrow
      select.select(v-model="brand" autocomplete="ño" required)
        option(value="")
        option(v-for="brand in brands" :value="brand") {{ capitalize(brand) }}
      label.label(:class="{ show: brand }") Marca

    .container-actions
      shActionButton(:isForm="true" :action="getStockValue" text="Obtener Stock" textRunning="Obteniendo Stock")

  .container-report
    table.stock-table.table-breakdown
      thead
        tr
          th Categoría
          th Productos
          th Unidad
          th Wholesaler
          th Promoción
          th Costo
      tbody
        tr
          td.left General
          td {{ number(stockValue.totalProducts) }}
          td {{ money(stockValue.totalUnit) }}
          td {{ money(stockValue.totalWholesaler) }}
          td {{ money(stockValue.totalSale) }}
          td {{ money(stockValue.totalCost) }}
        tr(v-for="(item, key) in stockValue.totalsByArticle")
          td.capitalize {{ key }}
          td {{ number(item.totalProducts) }}
          td {{ money(item.totalUnit) }}
          td {{ money(item.totalWholesaler) }}
          td {{ money(item.totalSale) }}
          td {{ money(item.totalCost) }}

    template(v-if="stockValue.productsWithZeroCost.length")
      h3.capitalize Productos con costo en 0
      table.stock-table.table-breakdown
        thead
          tr
            th Producto
            th Artículo
            th Diseño
            th Stock
        tbody
          tr(v-for="product in stockValue.productsWithZeroCost" :key="product.product")
            td {{ product.product }}
            td.capitalize {{ product.article }}
            td.capitalize {{ product.design }}
            td {{ number(product.totalAvailable) }}
</template>

<script>
import mFilters from '@/mixins/filters'
import mForm from '@/mixins/form'

export default {
  name: 'ReportStock',

  mixins: [mFilters, mForm],

  data () {
    return {
      brand: ''
    }
  },

  methods: {
    async getStockValue () {
      this.$store.commit('setBrand', { report: 'stock', brand: this.brand })
      await this.$store.dispatch('getStockValue')
    }
  },

  computed: {
    brands () {
      return this.$store.state.variables.brands
    },
    stockValue () {
      return this.$store.state.reports.stockValue
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/reports/Stock.vue